import { Base } from './base-model';

export class ParentEducationMoment extends Base {
    name: string
    description: string
    types: string

    typesList(): string[] {
        // return this.types.splitTrim()  // for some reason isn't working for this class????
        return this.types.split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    static defaults(): ParentEducationMoment {
        const pem = new ParentEducationMoment()
        pem.name = ''
        pem.description = ''
        pem.types = ''
        return pem
    }

    copyFrom(pem: ParentEducationMoment) {
        super.copyFrom(pem)
        this.name = pem.name
        this.description = pem.description
        this.types = pem.types
    }

    get isDirty(): boolean { 
        return super.isDirty && (this.dirtyDate || 0) > (this.synced || 0)
    }
    set isDirty(dirty: boolean) { super.isDirty = dirty }

    get isWeekOne(): boolean {
        return this.name.toLowerCase().startsWith('week one')
    }
}
